import * as React from 'react'
import { I18n } from 'react-redux-i18n'

import './styles.scss'
import { getStaticImage } from 'utils/statics'
import dkvConfiguration from 'constants/dkv.constants'

const SurveysList = (props) => {
  const { surveys, edit, remove } = props

  return (
    surveys.map((it) => {
      return (
        <div key={it._id} className='animated fadeIn'>
          <div className='survey'>
            <span className='name text-ellipsis'>{it.name}</span>
            <div className='survey-details'>
              <div className='detail'>
                <span className='title'>{I18n.t('dashboard_brand')}</span>
                {it.brands.map(b => (
                  b._id === 'all' || b._id === 'some'
                    ? <span key={b._id}>{I18n.t(`dashboard_${b._id}-plural-female`)}</span>
                    : <span key={b._id}>{b.name}</span>
                ))}
              </div>
              <div className='detail'>
                <span className='title'>{I18n.t('dashboard_delegation')}</span>
                {it.delegations.map(b => (
                  b._id === 'all' || b._id === 'some'
                    ? <span key={b._id}>{I18n.t(`dashboard_${b._id}-plural-female`)}</span>
                    : <span key={b._id}>{b.name}</span>
                ))}
              </div>
              <div className='detail'>
                <span className='title'>{I18n.t('dashboard_identifier')}</span>
                <span>{it.identifier}</span>
              </div>
              {
                dkvConfiguration.isDKV ? (
                  <div className='detail'>
                    <span className='title'>{I18n.t('dashboard_type')}</span>
                    {it.type === 'operatorEmail'
                      ? <span>{I18n.t('dashboard_operator-email')}</span>
                      : <span>{I18n.t('dashboard_customer-id')}</span>
                    }
                  </div>
                ) : <div className='detail'></div>
              }
            </div>
            <div className='survey-icons'>
              <img src={getStaticImage('/icons/orange-brand/icon-edit.svg')} alt='Edit' onClick={() => edit(it)}/>
              {it.allowRemove && <img src={getStaticImage('/icons/orange-brand/icon-delete.svg')} alt='Delete' onClick={()=>remove(it)}/>}
            </div>
          </div>
        </div>
      )
    })
  )
}

export default SurveysList
